export default __webpack_public_path__ + "static/media/bTRI-BNB.743d8d0c.png";